import { render, staticRenderFns } from "./ValueTemplate.vue?vue&type=template&id=1975d47e&scoped=true&"
import script from "./ValueTemplate.vue?vue&type=script&lang=js&"
export * from "./ValueTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ValueTemplate.vue?vue&type=style&index=0&id=1975d47e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1975d47e",
  null
  
)

export default component.exports